import React, {useState} from 'react'
import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {cssTheme} from '@vio/atlas/themes'

const UnstyledButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
`

const Wrapper = styled.div`
  display: flex;
  color: ${cssTheme.colors.border.accent.secondary};
  gap: ${cssTheme.layout.spacing.s400};
  svg {
    height: 40px;
  }
`

const StyledIcon = styled(Icon)`
  margin-left: ${cssTheme.layout.spacing.s100};
`

type StarRatingProps = {
  totalStars: number
  onRateChange: (value) => void
}
export const StarRating = ({totalStars, onRateChange}: StarRatingProps) => {
  const [rating, setRating] = useState(0)

  const handleClick = star => {
    setRating(star)
    onRateChange(star)
  }

  return (
    <Wrapper>
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1
        return (
          <UnstyledButton
            key={`star-${index}`}
            onClick={() => handleClick(starValue)}
          >
            <StyledIcon
              size="xl"
              name={starValue <= rating ? 'StarSolid' : 'StarOutline'}
              colorPath="border.accent.primary"
            />
          </UnstyledButton>
        )
      })}
    </Wrapper>
  )
}
